<template>
    <div class="setting-style-width d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label
                for="styleFontSize"
                class="font-14 m-0"
            >
                Tamanho da Fonte
            </label>

            <div class="ml-3 d-flex justify-content-center align-items-center">
                <button id="deslock" v-if="isLockStyleFontSize" @click="handlerUnlockStyleFontSize">
                    <i class="fal fa-lock font-14"></i>
                </button>

                <button id="lock" v-else @click="handlerLockStyleFontSize">
                    <i class="fal fa-lock-open font-14"></i>
                </button>
            </div>
        </div>

        <div class="row no-gutters">
            <input
                class="col-2 form-control" 
                type="number"
                id="styleFontSizeInput"
                name="styleFontSizeInput"
                v-model="styleFontSize"
                :min="minValue"
                :max="maxValue"
                :disabled="isLockStyleFontSize"
            />

            <select
                id="styleFontSizeMetric"
                name="styleFontSizeMetric"
                class="col-2"
                style="color: #495057; cursor: not-allowed;"
                v-model="metricActive"
                disabled
            >
                <option
                    v-for="metric in metrics"
                    :key="metric.id"
                    :value="metric.value"
                >
                    {{ metric.label }}
                </option>
            </select>

            <input
                id="styleFontSizeRange"
                name="styleFontSizeRange"
                class="col px-2"
                type="range"
                :max="maxValue"
                :min="minValue"
                v-model="styleFontSize"
                :disabled="isLockStyleFontSize"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameStyleFontSize',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            styleFontSize: 0,
            minValue: 14,
            maxValue: 200,
            metrics: [
                {
                    id: 1,
                    value: 'px',
                    label: 'px',
                },
                {
                    id: 2,
                    value: '%',
                    label: '%',
                },
                {
                    id: 3,
                    value: 'vh',
                    label: 'vh',
                }
            ],
            metricActive: null,
        }
    },
    methods: {
        handlerLockStyleFontSize() {
            this.$emit('onChangeStyleFontSizeLock', true);
        },
        handlerUnlockStyleFontSize() {
            this.$emit('onChangeStyleFontSizeLock', false);
        },
    },
    computed: {
        isLockStyleFontSize() {
            return !!this.item.extra.style_font_size_lock;
        },
    },
    watch: {
        styleFontSize() {
            const styleFontSize = `${this.styleFontSize}${this.metricActive}`;

            this.$emit('onChangeStyleFontSize', styleFontSize);
        },
    },
    created() {
        const fontSize = `${this.item.extra.style.fontSize || '16px'}`;
        const metricActive = this.metrics.find(metric => fontSize.indexOf(metric.value) > -1);

        this.metricActive = metricActive ? metricActive.value : 'px';
        this.styleFontSize = parseFloat(fontSize);
    },
}
</script>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */

   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
   border-radius: 50%;
}

input[type="range"]:focus::-webkit-slider-thumb {   
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}


#deslock, #lock {
    background: transparent;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleFontSize.vue